module.exports = __webpack_public_path__ + "static/media/icon_project_folder.0e4f482f.svg";